/**
 * @generated SignedSource<<efe7917217e4f87f35f731eb840a979a>>
 * @relayHash 3783896b6093a3bf5578de32b86cb5f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 31632af95addefbf3ff68034c57ec4057f70f2007814f9a83cb77b27dd55472a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentWorkspaceWorkforceTeamAccessLevel = "TEAM_ADMIN" | "TEAM_MEMBER" | "%future added value";
export type JsmProjectMenuWrapper_SidebarQuery$variables = {
  accountIds?: ReadonlyArray<string> | null;
  cloudId: string;
  includeWorkforceTeamAccess: boolean;
  projectKey: string;
  workforceProjectKey: string;
};
export type JsmProjectMenuWrapper_SidebarQuery$data = {
  readonly agentWorkspace_workforceTeamAccessLevels?: {
    readonly accessLevels: ReadonlyArray<{
      readonly accessLevel: AgentWorkspaceWorkforceTeamAccessLevel;
    }>;
    readonly errors: ReadonlyArray<{
      readonly __typename: "AgentWorkspaceWorkforceTeamAccessError";
    }>;
  } | null;
  readonly jira_projectLevelSidebarMenuCustomization: {
    readonly __typename: "JiraProjectLevelSidebarMenuCustomization";
    readonly hiddenMenuItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly itemId: string;
        } | null;
      } | null> | null;
    } | null;
    readonly renamedMenuItems: {
      readonly " $fragmentSpreads": FragmentRefs<"JsmProjectMenuContent_renamedMenuItems">;
    } | null;
  } | {
    readonly __typename: "QueryError";
    readonly __typename: "QueryError";
    readonly message: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type JsmProjectMenuWrapper_SidebarQuery = {
  response: JsmProjectMenuWrapper_SidebarQuery$data;
  variables: JsmProjectMenuWrapper_SidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeWorkforceTeamAccess"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workforceProjectKey"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = [
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "projectKey",
    "variableName": "projectKey"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "itemId"
},
v9 = {
  "concreteType": "JiraProjectLevelSidebarMenuItemConnection",
  "kind": "LinkedField",
  "name": "hiddenMenuItems",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraProjectLevelSidebarMenuItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraProjectLevelSidebarMenuItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/)
          ]
        }
      ]
    }
  ]
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
},
v11 = {
  "condition": "includeWorkforceTeamAccess",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountIds",
          "variableName": "accountIds"
        },
        (v5/*: any*/),
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "workforceProjectKey"
        }
      ],
      "concreteType": "AgentWorkspaceWorkforceTeamAccessLevelsPayload",
      "kind": "LinkedField",
      "name": "agentWorkspace_workforceTeamAccessLevels",
      "plural": false,
      "selections": [
        {
          "concreteType": "AgentWorkspaceWorkforceTeamAccessLevelResult",
          "kind": "LinkedField",
          "name": "accessLevels",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accessLevel"
            }
          ]
        },
        {
          "concreteType": "AgentWorkspaceWorkforceTeamAccessError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": [
            (v7/*: any*/)
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JsmProjectMenuWrapper_SidebarQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "kind": "LinkedField",
        "name": "jira_projectLevelSidebarMenuCustomization",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*: any*/),
              {
                "concreteType": "JiraProjectLevelSidebarRenamedMenuItemConnection",
                "kind": "LinkedField",
                "name": "renamedMenuItems",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "JsmProjectMenuContent_renamedMenuItems"
                  }
                ]
              }
            ],
            "type": "JiraProjectLevelSidebarMenuCustomization"
          },
          (v10/*: any*/)
        ]
      },
      (v11/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "JsmProjectMenuWrapper_SidebarQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "kind": "LinkedField",
        "name": "jira_projectLevelSidebarMenuCustomization",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*: any*/),
              {
                "concreteType": "JiraProjectLevelSidebarRenamedMenuItemConnection",
                "kind": "LinkedField",
                "name": "renamedMenuItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectLevelSidebarRenamedMenuItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraProjectLevelSidebarRenamedMenuItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "renamedMenuItemName"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ],
            "type": "JiraProjectLevelSidebarMenuCustomization"
          },
          (v10/*: any*/)
        ]
      },
      (v11/*: any*/)
    ]
  },
  "params": {
    "id": "31632af95addefbf3ff68034c57ec4057f70f2007814f9a83cb77b27dd55472a",
    "metadata": {},
    "name": "JsmProjectMenuWrapper_SidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3a40084a73e60bee53ee8519bd13c02d";

export default node;
